import { render, staticRenderFns } from "./dividendPolicy.vue?vue&type=template&id=73ce9078&scoped=true"
import script from "./dividendPolicy.vue?vue&type=script&lang=js"
export * from "./dividendPolicy.vue?vue&type=script&lang=js"
import style0 from "./dividendPolicy.vue?vue&type=style&index=0&id=73ce9078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ce9078",
  null
  
)

export default component.exports